import { render, staticRenderFns } from "./LoadingVehicle.vue?vue&type=template&id=b2584470&scoped=true&"
import script from "./LoadingVehicle.vue?vue&type=script&lang=js&"
export * from "./LoadingVehicle.vue?vue&type=script&lang=js&"
import style0 from "./LoadingVehicle.vue?vue&type=style&index=0&id=b2584470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2584470",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VPagination,VRow,VSimpleTable,VTextField})
